import { createSlice } from '@reduxjs/toolkit';

import { contentLoaded } from '../../actions/comboSummaryActions';

// Filled before the summary fetch even starts: the thunk awaits the content call, dispatches this,
// and only then begins the labels and summary requests.
const destinationContentSlice = createSlice({
  name: 'destinationContent',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(contentLoaded, (_state, action) => action.payload);
  },
});

export default destinationContentSlice.reducer;
